// Copyright (c) 2026 AesirX.io Ltd. All rights reserved.
// This source code is proprietary and confidential.
// See LICENSE.md for licensing terms.
/**
 * Module Configuration types.
 * Collection: grc_module_config
 * Sprint 4.4.0 -- Platform Settings Consolidation & Module Configuration
 */
/** Identifiers for toggleable modules */
export const ModuleId = {
    RIGHTS_REQUESTS: 'rights_requests',
    DATA_MAPPING: 'data_mapping',
    GOVERNANCE: 'governance',
    CONSENT: 'consent',
    CONSENT_PROPERTIES: 'consent_properties',
    // Sprint 40.2.0 - Data Subject Profiles (part of Light tier, positioned after Consent Properties)
    DATA_SUBJECTS: 'data_subjects',
    ASSESSMENTS: 'assessments',
    CLASSIFICATION: 'classification',
    MONITORING: 'monitoring',
    INCIDENTS: 'incidents',
    CONNECTORS: 'connectors',
    VENDOR_RISK: 'vendor_risk',
    DELETION_ORCHESTRATION: 'deletion_orchestration',
    DISCOVERY: 'discovery',
    INCIDENT_OPS: 'incident_ops',
    PROGRAM_GOVERNANCE: 'program_governance',
    ACCESS_ACCOUNTABILITY: 'access_accountability',
    LOCALIZATION: 'localization',
    PARTNER_WORKSPACE: 'partner_workspace',
    PRIVACY_SCANNER: 'privacy_scanner',
    ONBOARDING: 'onboarding',
    // Sprint 15.5.0 - Add missing sidebar modules
    COMPLIANCE_FORMS: 'compliance_forms',
    AUDIT_TRAIL: 'audit_trail',
    ORGANIZATIONS: 'organizations',
    // Sprint 17.4.0 - Task Management
    TASK_MANAGEMENT: 'task_management',
    // Sprint 31.x - Help Center
    HELP_CENTER: 'help_center',
    // Sprint 63.42.0 (owner ruling OR-26) — Module 30, Sector Overlays: the
    // optional overlay installer and the registers an activated overlay brings
    // into use. Enterprise-only (`ENTERPRISE_MODULES`), enforced on the server by
    // `requireModuleEntitlement` and `OptionalOverlayPolicy`'s `not_entitled`.
    SECTOR_OVERLAYS: 'sector_overlays',
};
/** All module IDs as an array for iteration */
export const ALL_MODULE_IDS = Object.values(ModuleId);
/*
 * `MODULE_DISPLAY_NAMES` stood here: a bilingual map of module names that no
 * page, route or service read. Every surface that shows a module's name reads
 * `t.module_labels[<ModuleId>]` from the locale bundles (Module Configuration,
 * License Settings, the Setup Wizard, Persona Onboarding, the Help Centre), so a
 * rename made here changed nothing a user sees, and the map could only drift.
 * Retired by fix-sprint-20260809-2123 (Low-Severity note 6); the canonical
 * descriptive name of a module is `t.module_labels`. `module-config.test.ts`
 * fails if the export comes back.
 */
/** Build a default config with all modules enabled */
export function buildDefaultModuleConfig() {
    const modules = {};
    for (const id of ALL_MODULE_IDS) {
        modules[id] = { enabled: true };
    }
    return modules;
}
//# sourceMappingURL=module-config.js.map